module.exports = __webpack_public_path__ + "static/img/123.82889548.jpg";